<div class="accordion" id="accordionSummaryReservation">
  <div class="accordion-item">
    <button
      *ngIf="!readOnly"
      class="sidebar__trigger"
      data-bs-toggle="collapse"
      data-bs-target="#collapseSummaryReservation"
      aria-expanded="true"
      aria-controls="collapseSummaryReservation"
      [class.collapsed]="collapseByVoucherSelected"
    >
      <h5 class="h5 sidebar__section-title">
        {{ 'sharedModule.bkgSummaryReservation.yourReservation' | translate }}
      </h5>
    </button>
    <h5
      *ngIf="readOnly && !isConfirmationStep"
      class="h5 sidebar__section-title"
    >
      {{ 'sharedModule.bkgSummaryReservation.yourReservation' | translate }}
    </h5>
    <h5 *ngIf="isConfirmationStep" class="h5 sidebar__section-title">
      Parking
    </h5>
    <div
      id="collapseSummaryReservation"
      class="accordion-collapse collapse"
      [class.show]="!collapseByVoucherSelected"
      data-bs-parent="#accordionSummaryReservation"
    >
      <div class="accordion-body">
        <div class="sidebar__content">
          <div class="sidebar__content-item">
            <strong>
              {{ bookingData?.product?.name }}
            </strong>
          </div>
          <div class="sidebar__content-item">
            {{ bookingData?.place?.name }}
            <span *ngIf="inTerminal"> - {{ inTerminal }}</span>
          </div>
          <div *ngIf="difTerminal" class="sidebar__content-item">
            {{ 'sharedModule.bkgSummaryReservation.outTerminal' | translate }}
            <span> {{ outTerminal }}</span>
          </div>

          <div class="sidebar__content-item">
            <strong *ngIf="!isPremium">
              {{ 'sharedModule.bkgSummaryReservation.checkIn' | translate }}
            </strong>
            <strong *ngIf="isPremium">
              {{
                'sharedModule.bkgSummaryReservation.checkInPremium' | translate
              }}
            </strong>
            {{
              bookingData?.startDate
                | date: 'dd-MM-YYYY, HH:mm':TIMEZONE_UTC_START
            }}
            <div *ngIf="hasPassengers" class="sidebar__passengers">
              {{ tripData.in_passengers }}
            </div>
          </div>
          <div class="sidebar__content-item">
            <strong *ngIf="!isPremium">
              {{ 'sharedModule.bkgSummaryReservation.checkOut' | translate }}
            </strong>
            <strong *ngIf="isPremium">
              {{
                'sharedModule.bkgSummaryReservation.checkOutPremium' | translate
              }}
            </strong>
            {{
              bookingData?.endDate | date: 'dd-MM-YYYY, HH:mm':TIMEZONE_UTC_END
            }}
            <div *ngIf="hasPassengers" class="sidebar__passengers">
              {{ tripData.out_passengers }}
            </div>
            <div *ngIf="hasFlightNumber" class="sidebar__flight">
              {{ tripData.flight_number }}
            </div>

            <p *ngIf="diffTimeZone">
              {{
                'sharedModule.bkgSummaryReservation.diffTimeZone' | translate
              }}
            </p>
          </div>

          <div *ngIf="!readOnly" class="sidebar__content-action">
            <a (click)="onClickModifyButton()">
              {{ 'sharedModule.bkgSummaryReservation.modify' | translate }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
